'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Links;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _group = require('@vx/group');

var _Graph = require('./Graph');

var _Graph2 = _interopRequireDefault(_Graph);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Links(_ref) {
  var links = _ref.links,
      linkComponent = _ref.linkComponent,
      className = _ref.className;
  return _react2.default.createElement(_group.Group, null, links.map(function (link, i) {
    return _react2.default.createElement(_group.Group, {
      className: (0, _classnames2.default)('vx-network-links', className),
      key: 'network-link-' + i
    }, _react2.default.createElement(linkComponent, {
      link: link
    }));
  }));
}